import { render, staticRenderFns } from "./catalogue-management.vue?vue&type=template&id=407be198&scoped=true"
import script from "./catalogue-management.vue?vue&type=script&lang=js"
export * from "./catalogue-management.vue?vue&type=script&lang=js"
import style0 from "./catalogue-management.vue?vue&type=style&index=0&id=407be198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407be198",
  null
  
)

export default component.exports